// Translation keys for the flag-gated New Season editors.
//
// Registered with i18next.addResourceBundle(..., deep = true, overwrite = false)
// instead of being added to app/i18n.js, so the existing bundle is untouched
// and no existing key can be overridden. Every key is prefixed `new_season_`.
const i18nModule = require('i18next');

const i18n = i18nModule.default || i18nModule;

const NAMESPACE = 'translations';

const en = {
  new_season_delete_only_season_text:
    'The block has no other season, so it goes back to a new block: only its name and polygon stay.',
  new_season_delete_only_season_unavailable:
    "This is the block's only season, and it cannot be deleted here yet.",
  new_season_delete_pre_season_failed:
    "The season was deleted, but the block's pre-season could not be created: {{message}}",
  new_season_discard_changes: 'You have unsaved changes. Discard them?',
  new_season_archive_season_title: 'Archive {{name}}?',
  new_season_archive_season_text: 'The season will move to Archive.',
  new_season_archived: '{{name}} moved to Archive',
  new_season_delete_season_title: 'Delete {{name}}?',
  new_season_delete_season_text: 'The season will be deleted.',
  new_season_deleted: '{{name}} season deleted',
  new_season_get_data_from: 'Get data from',
  new_season_get_data_this_block: 'This block',
  new_season_get_data_discard:
    'You have unsaved changes. Discard them and get this data?',
  new_season_get_data_copied: 'Data copied. Save changes to keep it',
  new_season_get_data_no_pre_season: 'No other block has a pre-season',
  new_season_get_data_no_active: 'No block has an active season',
  new_season_get_data_no_archive: 'This block has no archived seasons',
  new_season_required: 'Required',
  new_season_irrigation_rate_invalid:
    'Enter an irrigation rate of at least {{min}}',
  new_season_fix_errors: 'Fix the highlighted fields before saving',
  new_season_sow_after_harvest:
    'The sow date must be before the harvest date ({{harvest}})',
  new_season_activate_incomplete:
    'Complete the pre-season (soil, crop, farming type, sow date and irrigation) before activating it',
  new_season_activate_advance_incomplete:
    'Complete the Advance section (such as the KC table) before activating the pre-season',
  new_season_season_actions: 'Season actions',
  new_season_activate_now: 'Activate now',
  new_season_activate_title: 'Activate {{name}}?',
  new_season_activate_text_archive:
    'The current active season ({{season}}) will move to Archive.',
  new_season_activate_text_no_active: 'The block has no active season.',
  new_season_activate_text_sensors:
    'The new active season starts without sensors.',
  new_season_activate_save_first:
    'Save your changes before activating the pre-season',
  new_season_activated: '{{name}} is now active',
  new_season_created_not_found:
    'The farming unit was created but could not be opened yet. Reload and choose it from the list.',
  new_season_detail_failed: 'Could not load the season: {{message}}',
  new_season_sensors_missing:
    'The season sensors were not loaded, so it was not saved',
  new_season_create_new: 'Create new',
  new_season_manage_farming_unit: 'Manage farming unit',
  new_season_create_farming_unit: 'Create new farming unit',
  new_season_edit_farming_unit: 'Edit farming unit',
  new_season_unit_name: 'Unit name',
  new_season_monday_id: 'Monday ID',
  new_season_enter: 'Enter',
  new_season_select: 'Select',
  new_season_unit_sensors: 'Unit sensors',
  new_season_back_to_dashboard: 'Back to dashboard',
  new_season_tab_farming_unit: 'FARMING UNIT',
  new_season_tab_seasons: 'SEASONS',
  new_season_tab_meta_data: 'Meta data',
  new_season_tab_fields: 'Fields',
  new_season_tab_sensors: 'Sensors',
  new_season_drop_kmz: 'Drag and drop a KMZ file',
  new_season_or: 'or',
  new_season_browse: 'browse your computer',
  new_season_empty_blocks: 'Draw a polygon on the map to get started',
  new_season_group: 'Group',
  new_season_ungroup: 'Ungroup',
  new_season_delete_field: 'Delete field',
  new_season_delete_block_title: 'Delete Block',
  new_season_delete_block_text:
    'Deleting this block will also delete all of its seasons',
  new_season_block_deleted: '{{name}} was deleted',
  new_season_delete_blocks_title: 'Delete {{count}} blocks',
  new_season_delete_blocks_text:
    'Deleting these blocks will also delete all of their seasons',
  new_season_delete_field_title: 'Delete field',
  new_season_delete_field_text:
    'Deleting this field will also delete its blocks and all of their seasons',
  new_season_save_changes: 'Save changes',
  new_season_changes_saved: 'Changes saved',
  new_season_saved_reload_failed:
    'Changes saved, but the farming unit could not be reloaded: {{message}}',
  new_season_writes_disabled:
    'Editing blocks and fields is not enabled on this environment yet',
  new_season_read_only: 'You have view-only access to this farming unit',
  new_season_unsaved_changes: 'You have unsaved changes. Leave without saving?',
  new_season_tab_unsaved: 'Unsaved changes',
  new_season_dragging_blocks: '{{count}} blocks',
  new_season_invalid_names: 'Every block and field needs a name',
  new_season_draw: 'Draw',
  new_season_draw_radial: 'Radial',
  new_season_draw_free_form: 'Free form',
  new_season_draw_placeholder_block: 'Placeholder block',
  new_season_draw_landmark: 'Landmark',
  new_season_magic_wand: 'Magic wand',
  new_season_search_map: 'Search by name or coordinates',
  new_season_navigate: 'Navigate',
  new_season_not_found: 'No block or coordinates match "{{query}}"',
  new_season_home: 'Home',
  new_season_zoom_in: 'Zoom in',
  new_season_zoom_out: 'Zoom out',
  new_season_layers: 'Layers',
  new_season_satellite: 'Satellite',
  new_season_streets: 'Streets',
  new_season_block_prefix: 'Block',
  new_season_field_prefix: 'Field',
  new_season_manage_seasons: 'Manage seasons',
  new_season_pre_season: 'Pre season',
  new_season_active: 'Active',
  new_season_archive: 'Archive',
  new_season_bulk_select: 'Bulk select',
  new_season_bulk_edit: 'Bulk edit',
  new_season_crop: 'Crop',
  new_season_section_map: 'Map',
  new_season_section_general: 'General',
  new_season_section_dates: 'Dates',
  new_season_section_irrigation: 'Irrigation system',
  new_season_section_contract: 'Contract',
  new_season_irrigation_start_after_harvest:
    'The pre-season irrigation start date must be before the harvest date ({{harvest}})',
  new_season_advance_bulk: 'Advanced settings are edited one season at a time',
  new_season_advance_loading: 'Loading…',
  new_season_section_advance: 'Advance',
  new_season_sow: 'Sow',
  new_season_sow_info: 'The date the crop was sown or planted',
  new_season_irrigation_rate_label: 'Custom irrigation rate ({{unit}}/h)',
  new_season_multiple_values: 'Multiple values',
  new_season_select_season: 'Select a season from the list',
  new_season_no_active_seasons:
    'No active seasons in this farming unit. New blocks start in Pre season.',
  new_season_no_archived_seasons: 'No archived seasons in this farming unit.',
  new_season_no_blocks: 'No blocks in this farming unit yet.',
  new_season_sensors_table: 'Sensors list',
  new_season_sensor_id: 'ID',
  new_season_block: 'Block',
  new_season_label: 'Label',
  new_season_transmitter_id: 'Transmitter id',
  new_season_fertilizer_type: 'Fertilizer type',
  new_season_fertilizer_meter_id: 'Fertilizer meter ID',
  new_season_no_sensors: 'No sensors',
  new_season_unit_incomplete:
    'Fill in the unit name, Monday ID, country and region to save',
  new_season_sensors_read_only: 'Sensor editing is not available here yet',
  new_season_load_failed: 'Could not load the farming unit: {{message}}',
  new_season_retry: 'Retry',
  new_season_bulk_saved: 'Changes saved to {{count}} seasons',
  new_season_bulk_partial:
    'Saved {{saved}} of {{total}} seasons. Failed: {{failed}}',
  new_season_nothing_changed: 'Nothing to save',
};

const pt = {
  new_season_delete_only_season_text:
    'O bloco não tem outra temporada, então volta a ser um bloco novo: ficam apenas o nome e o polígono.',
  new_season_delete_only_season_unavailable:
    'Esta é a única temporada do bloco e ainda não pode ser excluída aqui.',
  new_season_delete_pre_season_failed:
    'A temporada foi excluída, mas a pré-temporada do bloco não pôde ser criada: {{message}}',
  new_season_discard_changes: 'Você tem alterações não salvas. Descartá-las?',
  new_season_archive_season_title: 'Arquivar {{name}}?',
  new_season_archive_season_text: 'A temporada será movida para o arquivo.',
  new_season_archived: '{{name}} movido para o arquivo',
  new_season_delete_season_title: 'Excluir {{name}}?',
  new_season_delete_season_text: 'A temporada será excluída.',
  new_season_deleted: 'Temporada de {{name}} excluída',
  new_season_get_data_from: 'Obter dados de',
  new_season_get_data_this_block: 'Este bloco',
  new_season_get_data_discard:
    'Você tem alterações não salvas. Descartá-las e obter estes dados?',
  new_season_get_data_copied:
    'Dados copiados. Salve as alterações para mantê-los',
  new_season_get_data_no_pre_season: 'Nenhum outro bloco tem pré-temporada',
  new_season_get_data_no_active: 'Nenhum bloco tem temporada ativa',
  new_season_get_data_no_archive: 'Este bloco não tem temporadas arquivadas',
  new_season_required: 'Obrigatório',
  new_season_irrigation_rate_invalid:
    'Insira uma taxa de irrigação de pelo menos {{min}}',
  new_season_fix_errors: 'Corrija os campos destacados antes de salvar',
  new_season_sow_after_harvest:
    'A data de plantio deve ser anterior à data de colheita ({{harvest}})',
  new_season_activate_incomplete:
    'Complete a pré-safra (solo, cultura, tipo de cultivo, data de plantio e irrigação) antes de ativá-la',
  new_season_activate_advance_incomplete:
    'Preencha a seção Avançado (como a tabela KC) antes de ativar a pré-safra',
  new_season_season_actions: 'Ações da safra',
  new_season_activate_now: 'Ativar agora',
  new_season_activate_title: 'Ativar {{name}}?',
  new_season_activate_text_archive:
    'A safra ativa atual ({{season}}) será movida para o Arquivo.',
  new_season_activate_text_no_active: 'O bloco não tem safra ativa.',
  new_season_activate_text_sensors: 'A nova safra ativa começa sem sensores.',
  new_season_activate_save_first:
    'Salve suas alterações antes de ativar a pré-safra',
  new_season_activated: '{{name}} agora está ativo',
  new_season_created_not_found:
    'A unidade foi criada, mas ainda não pôde ser aberta. Recarregue e escolha-a na lista.',
  new_season_detail_failed: 'Não foi possível carregar a safra: {{message}}',
  new_season_sensors_missing:
    'Os sensores da safra não foram carregados, então ela não foi salva',
  new_season_create_new: 'Criar novo',
  new_season_manage_farming_unit: 'Gerenciar unidade agrícola',
  new_season_create_farming_unit: 'Criar nova unidade agrícola',
  new_season_edit_farming_unit: 'Editar unidade agrícola',
  new_season_unit_name: 'Nome da unidade',
  new_season_monday_id: 'ID do Monday',
  new_season_enter: 'Digite',
  new_season_select: 'Selecione',
  new_season_unit_sensors: 'Sensores da unidade',
  new_season_back_to_dashboard: 'Voltar ao painel',
  new_season_tab_farming_unit: 'UNIDADE AGRÍCOLA',
  new_season_tab_seasons: 'SAFRAS',
  new_season_tab_meta_data: 'Metadados',
  new_season_tab_fields: 'Talhões',
  new_season_tab_sensors: 'Sensores',
  new_season_drop_kmz: 'Arraste e solte um arquivo KMZ',
  new_season_or: 'ou',
  new_season_browse: 'procure no seu computador',
  new_season_empty_blocks: 'Desenhe um polígono no mapa para começar',
  new_season_group: 'Agrupar',
  new_season_ungroup: 'Desagrupar',
  new_season_delete_field: 'Excluir talhão',
  new_season_delete_block_title: 'Excluir bloco',
  new_season_delete_block_text:
    'Excluir este bloco também excluirá todas as suas safras',
  new_season_block_deleted: '{{name}} foi excluído',
  new_season_delete_blocks_title: 'Excluir {{count}} blocos',
  new_season_delete_blocks_text:
    'Excluir estes blocos também excluirá todas as suas safras',
  new_season_delete_field_title: 'Excluir talhão',
  new_season_delete_field_text:
    'Excluir este talhão também excluirá seus blocos e todas as suas safras',
  new_season_save_changes: 'Salvar alterações',
  new_season_changes_saved: 'Alterações salvas',
  new_season_saved_reload_failed:
    'Alterações salvas, mas não foi possível recarregar a unidade: {{message}}',
  new_season_writes_disabled:
    'A edição de blocos e talhões ainda não está habilitada neste ambiente',
  new_season_read_only: 'Você tem acesso somente leitura a esta unidade',
  new_season_unsaved_changes: 'Há alterações não salvas. Sair sem salvar?',
  new_season_tab_unsaved: 'Alterações não salvas',
  new_season_dragging_blocks: '{{count}} blocos',
  new_season_invalid_names: 'Todo bloco e talhão precisa de um nome',
  new_season_draw: 'Desenhar',
  new_season_draw_radial: 'Radial',
  new_season_draw_free_form: 'Forma livre',
  new_season_draw_placeholder_block: 'Bloco provisório',
  new_season_draw_landmark: 'Ponto de referência',
  new_season_magic_wand: 'Varinha mágica',
  new_season_search_map: 'Pesquisar por nome ou coordenadas',
  new_season_navigate: 'Navegar',
  new_season_not_found: 'Nenhum bloco ou coordenada corresponde a "{{query}}"',
  new_season_home: 'Início',
  new_season_zoom_in: 'Aproximar',
  new_season_zoom_out: 'Afastar',
  new_season_layers: 'Camadas',
  new_season_satellite: 'Satélite',
  new_season_streets: 'Ruas',
  new_season_block_prefix: 'Bloco',
  new_season_field_prefix: 'Talhão',
  new_season_manage_seasons: 'Gerenciar safras',
  new_season_pre_season: 'Pré-safra',
  new_season_active: 'Ativas',
  new_season_archive: 'Arquivo',
  new_season_bulk_select: 'Seleção em massa',
  new_season_bulk_edit: 'Edição em massa',
  new_season_crop: 'Cultura',
  new_season_section_map: 'Mapa',
  new_season_section_general: 'Geral',
  new_season_section_dates: 'Datas',
  new_season_section_irrigation: 'Sistema de irrigação',
  new_season_section_contract: 'Contrato',
  new_season_irrigation_start_after_harvest:
    'A data de início da irrigação pré-safra deve ser anterior à data de colheita ({{harvest}})',
  new_season_advance_bulk:
    'As configurações avançadas são editadas uma safra por vez',
  new_season_advance_loading: 'Carregando…',
  new_season_section_advance: 'Avançado',
  new_season_sow: 'Plantio',
  new_season_sow_info: 'A data em que a cultura foi semeada ou plantada',
  new_season_irrigation_rate_label:
    'Taxa de irrigação personalizada ({{unit}}/h)',
  new_season_multiple_values: 'Valores múltiplos',
  new_season_select_season: 'Selecione uma safra na lista',
  new_season_no_active_seasons:
    'Nenhuma safra ativa nesta unidade agrícola. Novos blocos começam em Pré-safra.',
  new_season_no_archived_seasons:
    'Nenhuma safra arquivada nesta unidade agrícola.',
  new_season_no_blocks: 'Ainda não há blocos nesta unidade agrícola.',
  new_season_sensors_table: 'Sensores',
  new_season_sensor_id: 'ID',
  new_season_block: 'Bloco',
  new_season_label: 'Rótulo',
  new_season_transmitter_id: 'ID do transmissor',
  new_season_fertilizer_type: 'Tipo de fertilizante',
  new_season_fertilizer_meter_id: 'ID do medidor de fertilizante',
  new_season_no_sensors: 'Sem sensores',
  new_season_unit_incomplete:
    'Preencha nome da unidade, ID do Monday, país e região para salvar',
  new_season_sensors_read_only:
    'A edição de sensores ainda não está disponível aqui',
  new_season_load_failed: 'Não foi possível carregar a unidade: {{message}}',
  new_season_retry: 'Tentar novamente',
  new_season_bulk_saved: 'Alterações salvas em {{count}} safras',
  new_season_bulk_partial:
    '{{saved}} de {{total}} safras salvas. Falharam: {{failed}}',
  new_season_nothing_changed: 'Nada para salvar',
};

const zh = {
  new_season_delete_only_season_text:
    '该地块没有其他季，将恢复为新地块：只保留名称和多边形。',
  new_season_delete_only_season_unavailable:
    '这是该地块唯一的季，目前无法在此删除。',
  new_season_delete_pre_season_failed:
    '该季已删除，但无法创建地块的预季：{{message}}',
  new_season_discard_changes: '您有未保存的更改。要放弃吗？',
  new_season_archive_season_title: '归档 {{name}}？',
  new_season_archive_season_text: '该季将移至归档。',
  new_season_archived: '{{name}} 已移至归档',
  new_season_delete_season_title: '删除 {{name}}？',
  new_season_delete_season_text: '该季将被删除。',
  new_season_deleted: '{{name}} 的季已删除',
  new_season_get_data_from: '获取数据自',
  new_season_get_data_this_block: '此地块',
  new_season_get_data_discard:
    '您有未保存的更改。要放弃这些更改并获取此数据吗？',
  new_season_get_data_copied: '数据已复制。请保存更改以保留数据',
  new_season_get_data_no_pre_season: '没有其他地块有预季',
  new_season_get_data_no_active: '没有地块有活跃季',
  new_season_get_data_no_archive: '此地块没有已归档的季',
  new_season_required: '必填',
  new_season_irrigation_rate_invalid: '请输入至少 {{min}} 的灌溉速率',
  new_season_fix_errors: '保存前请修正标出的字段',
  new_season_sow_after_harvest: '播种日期必须早于收获日期（{{harvest}}）',
  new_season_activate_incomplete:
    '激活前请完善预季（土壤、作物、种植类型、播种日期和灌溉）',
  new_season_activate_advance_incomplete:
    '激活预季前请完善“高级”部分（例如 KC 表）',
  new_season_season_actions: '季节操作',
  new_season_activate_now: '立即激活',
  new_season_activate_title: '激活 {{name}}？',
  new_season_activate_text_archive: '当前活跃季节（{{season}}）将移至归档。',
  new_season_activate_text_no_active: '该地块没有活跃季节。',
  new_season_activate_text_sensors: '新的活跃季节开始时没有传感器。',
  new_season_activate_save_first: '激活预季前请先保存更改',
  new_season_activated: '{{name}} 现已激活',
  new_season_created_not_found:
    '农场单元已创建，但暂时无法打开。请刷新后从列表中选择。',
  new_season_detail_failed: '无法加载季节：{{message}}',
  new_season_sensors_missing: '未加载季节的传感器，因此未保存',
  new_season_create_new: '新建',
  new_season_manage_farming_unit: '管理农场单元',
  new_season_create_farming_unit: '新建农场单元',
  new_season_edit_farming_unit: '编辑农场单元',
  new_season_unit_name: '单元名称',
  new_season_monday_id: 'Monday ID',
  new_season_enter: '输入',
  new_season_select: '选择',
  new_season_unit_sensors: '单元传感器',
  new_season_back_to_dashboard: '返回仪表板',
  new_season_tab_farming_unit: '农场单元',
  new_season_tab_seasons: '季节',
  new_season_tab_meta_data: '元数据',
  new_season_tab_fields: '田块',
  new_season_tab_sensors: '传感器',
  new_season_drop_kmz: '拖放 KMZ 文件',
  new_season_or: '或',
  new_season_browse: '浏览您的电脑',
  new_season_empty_blocks: '在地图上绘制多边形以开始',
  new_season_group: '分组',
  new_season_ungroup: '取消分组',
  new_season_delete_field: '删除田块',
  new_season_delete_block_title: '删除地块',
  new_season_delete_block_text: '删除此地块也会删除其所有季节',
  new_season_block_deleted: '{{name}} 已删除',
  new_season_delete_blocks_title: '删除 {{count}} 个地块',
  new_season_delete_blocks_text: '删除这些地块也会删除它们的所有季节',
  new_season_delete_field_title: '删除田块',
  new_season_delete_field_text: '删除此田块也会删除其地块及其所有季节',
  new_season_save_changes: '保存更改',
  new_season_changes_saved: '更改已保存',
  new_season_saved_reload_failed:
    '更改已保存，但无法重新加载农场单元：{{message}}',
  new_season_writes_disabled: '此环境尚未启用地块和田块编辑',
  new_season_read_only: '您对此农场单元只有查看权限',
  new_season_unsaved_changes: '您有未保存的更改。是否不保存就离开？',
  new_season_tab_unsaved: '未保存的更改',
  new_season_dragging_blocks: '{{count}} 个地块',
  new_season_invalid_names: '每个地块和田块都需要名称',
  new_season_draw: '绘制',
  new_season_draw_radial: '圆形',
  new_season_draw_free_form: '自由形状',
  new_season_draw_placeholder_block: '占位地块',
  new_season_draw_landmark: '地标',
  new_season_magic_wand: '魔棒',
  new_season_search_map: '按名称或坐标搜索',
  new_season_navigate: '导航',
  new_season_not_found: '没有与"{{query}}"匹配的地块或坐标',
  new_season_home: '主页',
  new_season_zoom_in: '放大',
  new_season_zoom_out: '缩小',
  new_season_layers: '图层',
  new_season_satellite: '卫星',
  new_season_streets: '街道',
  new_season_block_prefix: '地块',
  new_season_field_prefix: '田块',
  new_season_manage_seasons: '管理季节',
  new_season_pre_season: '季前',
  new_season_active: '进行中',
  new_season_archive: '归档',
  new_season_bulk_select: '批量选择',
  new_season_bulk_edit: '批量编辑',
  new_season_crop: '作物',
  new_season_section_map: '地图',
  new_season_section_general: '常规',
  new_season_section_dates: '日期',
  new_season_section_irrigation: '灌溉系统',
  new_season_section_contract: '合同',
  new_season_irrigation_start_after_harvest:
    '预季灌溉开始日期必须早于收获日期（{{harvest}}）',
  new_season_advance_bulk: '高级设置一次只能编辑一个季节',
  new_season_advance_loading: '加载中…',
  new_season_section_advance: '高级',
  new_season_sow: '播种',
  new_season_sow_info: '作物播种或种植的日期',
  new_season_irrigation_rate_label: '自定义灌溉速率（{{unit}}/h）',
  new_season_multiple_values: '多个值',
  new_season_select_season: '从列表中选择一个季节',
  new_season_no_active_seasons:
    '此农场单元没有进行中的季节。新地块从“季前”开始。',
  new_season_no_archived_seasons: '此农场单元没有已归档的季节。',
  new_season_no_blocks: '此农场单元还没有地块。',
  new_season_sensors_table: '传感器',
  new_season_sensor_id: 'ID',
  new_season_block: '地块',
  new_season_label: '标签',
  new_season_transmitter_id: '发射器 ID',
  new_season_fertilizer_type: '肥料类型',
  new_season_fertilizer_meter_id: '肥料计量表 ID',
  new_season_no_sensors: '没有传感器',
  new_season_unit_incomplete: '请填写单元名称、Monday ID、国家和地区后再保存',
  new_season_sensors_read_only: '此处暂不支持编辑传感器',
  new_season_load_failed: '无法加载农场单元：{{message}}',
  new_season_retry: '重试',
  new_season_bulk_saved: '已将更改保存到 {{count}} 个季节',
  new_season_bulk_partial:
    '已保存 {{saved}}/{{total}} 个季节。失败：{{failed}}',
  new_season_nothing_changed: '没有需要保存的内容',
};

const es = {
  new_season_delete_only_season_text:
    'El bloque no tiene otra temporada, así que vuelve a ser un bloque nuevo: solo quedan su nombre y su polígono.',
  new_season_delete_only_season_unavailable:
    'Esta es la única temporada del bloque y aún no se puede eliminar aquí.',
  new_season_delete_pre_season_failed:
    'La temporada se eliminó, pero no se pudo crear la pretemporada del bloque: {{message}}',
  new_season_discard_changes: 'Tienes cambios sin guardar. ¿Descartarlos?',
  new_season_archive_season_title: '¿Archivar {{name}}?',
  new_season_archive_season_text: 'La temporada pasará al archivo.',
  new_season_archived: '{{name}} pasó al archivo',
  new_season_delete_season_title: '¿Eliminar {{name}}?',
  new_season_delete_season_text: 'La temporada se eliminará.',
  new_season_deleted: 'Temporada de {{name}} eliminada',
  new_season_get_data_from: 'Obtener datos de',
  new_season_get_data_this_block: 'Este bloque',
  new_season_get_data_discard:
    'Tienes cambios sin guardar. ¿Descartarlos y obtener estos datos?',
  new_season_get_data_copied:
    'Datos copiados. Guarda los cambios para conservarlos',
  new_season_get_data_no_pre_season: 'Ningún otro bloque tiene pretemporada',
  new_season_get_data_no_active: 'Ningún bloque tiene temporada activa',
  new_season_get_data_no_archive: 'Este bloque no tiene temporadas archivadas',
  new_season_required: 'Obligatorio',
  new_season_irrigation_rate_invalid:
    'Ingrese una tasa de riego de al menos {{min}}',
  new_season_fix_errors: 'Corrija los campos resaltados antes de guardar',
  new_season_sow_after_harvest:
    'La fecha de siembra debe ser anterior a la fecha de cosecha ({{harvest}})',
  new_season_activate_incomplete:
    'Complete la pretemporada (suelo, cultivo, tipo de cultivo, fecha de siembra y riego) antes de activarla',
  new_season_activate_advance_incomplete:
    'Complete la sección Avanzado (como la tabla KC) antes de activar la pretemporada',
  new_season_season_actions: 'Acciones de la temporada',
  new_season_activate_now: 'Activar ahora',
  new_season_activate_title: '¿Activar {{name}}?',
  new_season_activate_text_archive:
    'La temporada activa actual ({{season}}) pasará al Archivo.',
  new_season_activate_text_no_active: 'El bloque no tiene temporada activa.',
  new_season_activate_text_sensors:
    'La nueva temporada activa comienza sin sensores.',
  new_season_activate_save_first:
    'Guarde sus cambios antes de activar la pretemporada',
  new_season_activated: '{{name}} ahora está activo',
  new_season_created_not_found:
    'La unidad se creó, pero aún no se pudo abrir. Recargue y elíjala de la lista.',
  new_season_detail_failed: 'No se pudo cargar la temporada: {{message}}',
  new_season_sensors_missing:
    'No se cargaron los sensores de la temporada, por lo que no se guardó',
  new_season_create_new: 'Crear nuevo',
  new_season_manage_farming_unit: 'Gestionar unidad agrícola',
  new_season_create_farming_unit: 'Crear nueva unidad agrícola',
  new_season_edit_farming_unit: 'Editar unidad agrícola',
  new_season_unit_name: 'Nombre de la unidad',
  new_season_monday_id: 'ID de Monday',
  new_season_enter: 'Ingrese',
  new_season_select: 'Seleccione',
  new_season_unit_sensors: 'Sensores de la unidad',
  new_season_back_to_dashboard: 'Volver al panel',
  new_season_tab_farming_unit: 'UNIDAD AGRÍCOLA',
  new_season_tab_seasons: 'TEMPORADAS',
  new_season_tab_meta_data: 'Metadatos',
  new_season_tab_fields: 'Campos',
  new_season_tab_sensors: 'Sensores',
  new_season_drop_kmz: 'Arrastre y suelte un archivo KMZ',
  new_season_or: 'o',
  new_season_browse: 'busque en su computadora',
  new_season_empty_blocks: 'Dibuje un polígono en el mapa para comenzar',
  new_season_group: 'Agrupar',
  new_season_ungroup: 'Desagrupar',
  new_season_delete_field: 'Eliminar campo',
  new_season_delete_block_title: 'Eliminar bloque',
  new_season_delete_block_text:
    'Eliminar este bloque también eliminará todas sus temporadas',
  new_season_block_deleted: '{{name}} fue eliminado',
  new_season_delete_blocks_title: 'Eliminar {{count}} bloques',
  new_season_delete_blocks_text:
    'Eliminar estos bloques también eliminará todas sus temporadas',
  new_season_delete_field_title: 'Eliminar campo',
  new_season_delete_field_text:
    'Eliminar este campo también eliminará sus bloques y todas sus temporadas',
  new_season_save_changes: 'Guardar cambios',
  new_season_changes_saved: 'Cambios guardados',
  new_season_saved_reload_failed:
    'Cambios guardados, pero no se pudo recargar la unidad: {{message}}',
  new_season_writes_disabled:
    'La edición de bloques y campos aún no está habilitada en este entorno',
  new_season_read_only: 'Tiene acceso de solo lectura a esta unidad',
  new_season_unsaved_changes: 'Tiene cambios sin guardar. ¿Salir sin guardar?',
  new_season_tab_unsaved: 'Cambios sin guardar',
  new_season_dragging_blocks: '{{count}} bloques',
  new_season_invalid_names: 'Cada bloque y campo necesita un nombre',
  new_season_draw: 'Dibujar',
  new_season_draw_radial: 'Radial',
  new_season_draw_free_form: 'Forma libre',
  new_season_draw_placeholder_block: 'Bloque provisional',
  new_season_draw_landmark: 'Punto de referencia',
  new_season_magic_wand: 'Varita mágica',
  new_season_search_map: 'Buscar por nombre o coordenadas',
  new_season_navigate: 'Navegar',
  new_season_not_found: 'Ningún bloque o coordenada coincide con "{{query}}"',
  new_season_home: 'Inicio',
  new_season_zoom_in: 'Acercar',
  new_season_zoom_out: 'Alejar',
  new_season_layers: 'Capas',
  new_season_satellite: 'Satélite',
  new_season_streets: 'Calles',
  new_season_block_prefix: 'Bloque',
  new_season_field_prefix: 'Campo',
  new_season_manage_seasons: 'Gestionar temporadas',
  new_season_pre_season: 'Pretemporada',
  new_season_active: 'Activas',
  new_season_archive: 'Archivo',
  new_season_bulk_select: 'Selección múltiple',
  new_season_bulk_edit: 'Edición múltiple',
  new_season_crop: 'Cultivo',
  new_season_section_map: 'Mapa',
  new_season_section_general: 'General',
  new_season_section_dates: 'Fechas',
  new_season_section_irrigation: 'Sistema de riego',
  new_season_section_contract: 'Contrato',
  new_season_irrigation_start_after_harvest:
    'La fecha de inicio del riego de pretemporada debe ser anterior a la fecha de cosecha ({{harvest}})',
  new_season_advance_bulk:
    'La configuración avanzada se edita una temporada a la vez',
  new_season_advance_loading: 'Cargando…',
  new_season_section_advance: 'Avanzado',
  new_season_sow: 'Siembra',
  new_season_sow_info: 'La fecha en que se sembró o plantó el cultivo',
  new_season_irrigation_rate_label: 'Tasa de riego personalizada ({{unit}}/h)',
  new_season_multiple_values: 'Valores múltiples',
  new_season_select_season: 'Seleccione una temporada de la lista',
  new_season_no_active_seasons:
    'No hay temporadas activas en esta unidad agrícola. Los bloques nuevos empiezan en Pretemporada.',
  new_season_no_archived_seasons:
    'No hay temporadas archivadas en esta unidad agrícola.',
  new_season_no_blocks: 'Todavía no hay bloques en esta unidad agrícola.',
  new_season_sensors_table: 'Sensores',
  new_season_sensor_id: 'ID',
  new_season_block: 'Bloque',
  new_season_label: 'Etiqueta',
  new_season_transmitter_id: 'ID del transmisor',
  new_season_fertilizer_type: 'Tipo de fertilizante',
  new_season_fertilizer_meter_id: 'ID del medidor de fertilizante',
  new_season_no_sensors: 'Sin sensores',
  new_season_unit_incomplete:
    'Complete el nombre de la unidad, el ID de Monday, el país y la región para guardar',
  new_season_sensors_read_only:
    'La edición de sensores aún no está disponible aquí',
  new_season_load_failed: 'No se pudo cargar la unidad: {{message}}',
  new_season_retry: 'Reintentar',
  new_season_bulk_saved: 'Cambios guardados en {{count}} temporadas',
  new_season_bulk_partial:
    'Se guardaron {{saved}} de {{total}} temporadas. Fallaron: {{failed}}',
  new_season_nothing_changed: 'Nada que guardar',
};

const BUNDLES = { en, pt, zh, es };

const registerBundles = () => {
  Object.keys(BUNDLES).forEach((language) => {
    // deep = true, overwrite = false: never replaces an existing key.
    i18n.addResourceBundle(language, NAMESPACE, BUNDLES[language], true, false);
  });
};

let registered = false;
const registerNewSeasonTranslations = () => {
  if (registered) {
    return;
  }
  registered = true;
  if (i18n.isInitialized) {
    registerBundles();
  } else {
    i18n.on('initialized', registerBundles);
  }
};

module.exports = { registerNewSeasonTranslations, BUNDLES };
